'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n'], ['\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex-direction: column;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ErrorWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'ErrorState__ErrorWrapper'
})(_templateObject);

var ErrorState = function (_PureComponent) {
  _inherits(ErrorState, _PureComponent);

  function ErrorState() {
    _classCallCheck(this, ErrorState);

    return _possibleConstructorReturn(this, (ErrorState.__proto__ || Object.getPrototypeOf(ErrorState)).apply(this, arguments));
  }

  _createClass(ErrorState, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        ErrorWrapper,
        null,
        _react2.default.createElement(
          'h5',
          null,
          _react2.default.createElement(_FormattedMessage2.default, { message: 'conversations-visitor-ui.asyncError.body' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'm-top-3' },
          _react2.default.createElement(
            _UIButton2.default,
            { use: 'tertiary', onClick: this.props.retry },
            _react2.default.createElement(_FormattedMessage2.default, { message: 'conversations-visitor-ui.asyncError.retry' })
          )
        )
      );
    }
  }]);

  return ErrorState;
}(_react.PureComponent);

ErrorState.displayName = 'ErrorState';
ErrorState.propTypes = {
  retry: _react.PropTypes.func.isRequired
};

exports.default = ErrorState;
module.exports = exports['default'];